import React from "react";
import InnerCard from "../../shared-ui-components/InnerCard";
import {
  FileOutlined,
  LinkOutlined,
  PictureOutlined,
  CodeOutlined,
  FormOutlined,
  CloudOutlined,
} from "@ant-design/icons";
// Map fields to icons
const fieldIcons: Record<string, React.ReactElement> = {
  Title: <FileOutlined />,
  Hyperlinks: <LinkOutlined />,
  Images: <PictureOutlined />,
  Scripts: <CodeOutlined />,
  Forms: <FormOutlined />,
  ExternalResourceLinks: <CloudOutlined />,
};

interface HtmlSummaryProps {
  htmlElements: any;
}

const fieldOrder = [
  "Title",
  "Hyperlinks",
  "Images",
  "Scripts",
  "Forms",
  "ExternalResourceLinks",
];

export default function UrlHtmlSummaryTab({ htmlElements }: HtmlSummaryProps) {
  if (!htmlElements) {
    return <div>No HTML summary available.</div>;
  }

  return (
    <div className="url-html-summary-tab">
      <div className="top-summary-card-inner-cards-wrapper">
        {fieldOrder.map((field) => {
          const value = htmlElements[field];
          if (!value) return null;
          let content: React.ReactNode;
          if (typeof value === "object" && value !== null) {
            content = (
              <div className="html-summary-field-content">
                {Object.entries(value).map(([k, v]) => (
                  <div key={k}>
                    {k}: {String(v)}
                  </div>
                ))}
              </div>
            );
          } else {
            content = value;
          }
          return (
            <InnerCard
              key={field}
              className={`file-information-inner-card ${field.toLowerCase()}`}
            >
              {{
                header: {
                  icon: fieldIcons[field] || <FileOutlined />,
                  isIconHighlighted: true,
                  text: field,
                },
                content,
              }}
            </InnerCard>
          );
        })}
      </div>
    </div>
  );
}
